import React from "react";

function FeedbackCard({ feedback }) {
  return (
    <div className="d-flex flex-column testimonial-card testimonial-card--fixed position-relative">
      <div className="quote-icon" aria-hidden="true">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 20C10 16.6863 12.6863 14 16 14V10C10.4772 10 6 14.4772 6 20H10ZM16 14C19.3137 14 22 16.6863 22 20H26C26 14.4772 21.5228 10 16 10V14ZM10 20C10 23.3137 12.6863 26 16 26V30C10.4772 30 6 25.5228 6 20H10ZM16 26C19.3137 26 22 23.3137 22 20H26C26 25.5228 21.5228 30 16 30V26Z" fill="currentColor"/>
        </svg>
      </div>
      <div className="card-body testimonial-card-body">
        <div className="customer-name-badge">
          <span className="customer-icon">👤</span>
          <h3 className="card-title">{feedback.name}</h3>
        </div>

        <div className="testimonial-scroll-region">
          <div
            className="mt-3 card-text testimonial-content testimonial-content--html"
            dangerouslySetInnerHTML={{ __html: feedback.feedback }}
          />
        </div>
      </div>
    </div>
  );
}

export default FeedbackCard;
